import { render, staticRenderFns } from "./QuestionIframe.vue?vue&type=template&id=54edcb70&scoped=true&"
import script from "./QuestionIframe.vue?vue&type=script&lang=js&"
export * from "./QuestionIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54edcb70",
  null
  
)

export default component.exports